import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

export const REQUEST_ID_HEADER = 'X-Request-Id'

export function generateRequestId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  // Fallback for environments missing WebCrypto.
  return `req-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

/**
 * Attach a client-generated X-Request-Id to every request so client and server
 * logs can be correlated. If the caller already set one, keep theirs.
 */
export function installRequestIdInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const headers = (config.headers ?? {}) as Record<string, unknown>
    const existing = headers[REQUEST_ID_HEADER] ?? headers[REQUEST_ID_HEADER.toLowerCase()]
    if (existing === undefined || existing === null || existing === '') {
      headers[REQUEST_ID_HEADER] = generateRequestId()
    }
    config.headers = config.headers ?? (headers as InternalAxiosRequestConfig['headers'])
    return config
  })
}
